var _rect, _path, _path2, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlasticWrap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 88,
    viewBox: "0 0 128 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 88,
    fill: "#003E6B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-270 -270C-270 -271.105 -269.105 -272 -268 -272H312C313.105 -272 314 -271.105 314 -270V135C314 136.105 313.105 137 312 137H-268C-269.105 137 -270 136.105 -270 135V-270Z",
    fill: "#444444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-268 -271H312V-273H-268V-271ZM313 -270V135H315V-270H313ZM312 136H-268V138H312V136ZM-269 135V-270H-271V135H-269ZM-268 136C-268.552 136 -269 135.552 -269 135H-271C-271 136.657 -269.657 138 -268 138V136ZM313 135C313 135.552 312.552 136 312 136V138C313.657 138 315 136.657 315 135H313ZM312 -271C312.552 -271 313 -270.552 313 -270H315C315 -271.657 313.657 -273 312 -273V-271ZM-268 -273C-269.657 -273 -271 -271.657 -271 -270H-269C-269 -270.552 -268.552 -271 -268 -271V-273Z",
    fill: "white",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 5.02857H128V82.9714H0V5.02857Z",
    fill: "#B2C1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.76471 0L7.52941 5.02857H0L3.76471 0Z",
    fill: "#B2C1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2941 0L15.0588 5.02857H7.52941L11.2941 0Z",
    fill: "#B2C1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8235 0L22.5882 5.02857H15.0588L18.8235 0Z",
    fill: "#B2C1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3529 0L30.1176 5.02857H22.5882L26.3529 0Z",
    fill: "#B2C1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8824 0L37.6471 5.02857H30.1176L33.8824 0Z",
    fill: "#B2C1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4118 0L45.1765 5.02857H37.6471L41.4118 0Z",
    fill: "#B2C1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9412 0L52.7059 5.02857H45.1765L48.9412 0Z",
    fill: "#B2C1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4706 0L60.2353 5.02857H52.7059L56.4706 0Z",
    fill: "#B2C1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 0L67.7647 5.02857H60.2353L64 0Z",
    fill: "#B2C1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5294 0L75.2941 5.02857H67.7647L71.5294 0Z",
    fill: "#B2C1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0588 0L82.8235 5.02857H75.2941L79.0588 0Z",
    fill: "#B2C1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5882 0L90.3529 5.02857H82.8235L86.5882 0Z",
    fill: "#B2C1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1177 0L97.8824 5.02857H90.3529L94.1177 0Z",
    fill: "#B2C1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.647 0L105.412 5.02857H97.8824L101.647 0Z",
    fill: "#B2C1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.176 0L112.941 5.02857H105.412L109.176 0Z",
    fill: "#B2C1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.706 0L120.471 5.02857H112.941L116.706 0Z",
    fill: "#B2C1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.235 0L128 5.02857H120.471L124.235 0Z",
    fill: "#B2C1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.235 88L120.471 82.9714H128L124.235 88Z",
    fill: "#B2C1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.706 88L112.941 82.9714H120.471L116.706 88Z",
    fill: "#B2C1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.176 88L105.412 82.9714H112.941L109.176 88Z",
    fill: "#B2C1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.647 88L97.8824 82.9714H105.412L101.647 88Z",
    fill: "#B2C1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1177 88L90.3529 82.9714H97.8824L94.1177 88Z",
    fill: "#B2C1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5882 88L82.8235 82.9714H90.3529L86.5882 88Z",
    fill: "#B2C1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0588 88L75.2941 82.9714H82.8235L79.0588 88Z",
    fill: "#B2C1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5294 88L67.7647 82.9714L75.2941 82.9714L71.5294 88Z",
    fill: "#B2C1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 88L60.2353 82.9714H67.7647L64 88Z",
    fill: "#B2C1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4706 88L52.7059 82.9714H60.2353L56.4706 88Z",
    fill: "#B2C1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9412 88L45.1765 82.9714H52.7059L48.9412 88Z",
    fill: "#B2C1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4118 88L37.6471 82.9714H45.1765L41.4118 88Z",
    fill: "#B2C1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8824 88L30.1176 82.9714H37.6471L33.8824 88Z",
    fill: "#B2C1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3529 88L22.5882 82.9714H30.1176L26.3529 88Z",
    fill: "#B2C1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8235 88L15.0588 82.9714H22.5882L18.8235 88Z",
    fill: "#B2C1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2941 88L7.52941 82.9714H15.0588L11.2941 88Z",
    fill: "#B2C1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.76471 88L0 82.9714L7.52941 82.9714L3.76471 88Z",
    fill: "#B2C1CE"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.61
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.898 12.3059C115.636 10.5291 106.97 11.5508 101.399 12.2171C92.2682 13.372 82.9054 13.4164 73.6201 13.9939C67.8168 14.3492 62.1682 15.4597 56.2874 15.7706C52.7281 15.9483 48.4723 15.9039 45.5319 16.97C58.5314 17.3253 71.6856 17.6363 84.5304 16.7479C91.2623 16.2593 97.8394 14.9267 104.726 15.2376C102.405 18.347 91.8813 21.0121 87.0838 23.1887C81.7448 25.5874 75.7867 27.986 71.6857 31.0954C79.2687 31.2286 86.8517 25.4097 94.5895 24.4324C90.7206 28.2969 84.5304 31.1398 79.0366 34.2492C72.4594 37.9804 56.4422 43.6217 54.5078 48.8632C66.6561 43.5773 80.5067 39.0021 91.2623 32.8722C96.9882 29.5851 102.792 26.2981 108.595 23.0999C111.845 21.3231 117.493 19.9461 119.118 17.3697C117.416 17.4586 115.636 17.8139 113.857 17.7695C115.482 16.3037 124.457 13.5052 120.898 12.3059Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.784 21.3714C123.772 21.7712 120.29 22.7484 118.511 23.4591C96.9224 32.3431 70.6913 41.6267 55.2157 54.2863C62.7987 52.4651 70.7686 48.3341 77.5005 45.4468C81.6015 43.67 87.1728 40.3386 92.4344 39.85C87.7144 42.7817 82.7622 45.5801 77.81 48.3785C75.1018 49.8888 68.6794 52.6428 68.8342 55.0414C73.8638 53.5312 78.6612 50.5551 83.1491 48.4674C87.7918 46.3352 92.6666 44.4252 97.3093 42.3375C100.482 40.916 112.475 37.2292 112.785 34.8306C108.374 34.4308 103.113 35.5857 98.4699 35.4524C100.095 33.0538 107.523 31.0105 111.315 29.4558C114.642 28.0788 117.737 26.835 120.136 24.925C121.219 24.0366 123.772 22.704 125.32 22.171C125.088 21.8156 126.558 21.4603 125.784 21.3714Z",
    fill: "#7E8993"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4432 67.6083C33.0741 65.8759 36.2466 64.3212 39.0322 62.6777C42.6689 60.4567 47.9306 57.7027 50.252 55.0375L45.4545 57.5694C35.4728 62.5444 25.8005 67.3862 15.1998 71.7837C13.4975 72.4944 11.7178 73.2051 9.93807 73.9158C8.85478 74.36 4.05735 76.8031 5.2954 77.6915C7.15247 79.0241 14.3486 74.6265 16.9021 74.5821C16.2057 74.8931 15.664 75.3373 15.4319 75.8259C18.9913 76.0924 27.5029 74.1379 28.354 71.9169C27.9671 71.8725 23.4792 71.8725 23.4018 72.0058C24.0982 70.0957 28.4314 68.8964 30.4432 67.6083Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.0253 60.8172C86.7355 63.004 82.7684 64.9666 79.285 67.0412C74.7373 69.8449 68.1577 73.3214 65.2549 76.6857L71.254 73.4896C83.736 67.2095 95.8309 61.0976 109.087 55.5464C111.216 54.6492 113.441 53.7521 115.667 52.8549C117.021 52.2942 123.02 49.2102 121.472 48.0888C119.15 46.4066 110.151 51.9577 106.958 52.0138C107.829 51.6213 108.506 51.0606 108.797 50.4438C104.346 50.1074 93.7022 52.5745 92.6378 55.3782C93.1216 55.4342 98.7337 55.4342 98.8304 55.266C97.9596 57.6771 92.5411 59.1911 90.0253 60.8172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9306 28.2525C44.9903 28.3414 42.3594 30.0737 40.0381 31.0065C36.4787 32.4724 32.3777 34.9599 28.1993 35.6262C28.7409 32.8722 35.7049 30.1182 38.3358 27.8083C33.7705 29.4963 29.8242 31.584 25.5684 33.4496C23.7113 34.2492 21.7769 34.8266 19.9198 35.4929C19.2234 35.715 16.1283 37.6251 15.9735 37.6251C18.3723 37.7139 21.3126 36.7367 23.4792 36.1148C23.4018 36.559 22.7828 37.1364 22.009 37.7583C21.6995 37.936 21.39 38.0692 21.1579 38.2469C17.7532 40.157 12.8784 42.9998 11.3309 45.5761C16.1283 45.7538 20.3067 42.7333 24.1756 41.4896C24.4077 43.5329 18.9913 45.7983 17.8306 47.886C20.6162 47.9748 24.5625 45.2208 26.6517 44.2436C31.4491 41.9337 38.4131 39.1797 41.2761 35.9371C39.2643 36.5146 37.2525 37.092 35.3954 37.8471C33.3062 38.6911 29.8242 40.7788 27.1933 40.5123C31.217 35.3597 43.1332 32.961 47.9306 28.2525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2643 29.0077L38.6453 29.3186C38.6453 29.363 38.6453 29.4074 38.6453 29.4074C38.8774 29.3186 39.1095 29.1409 39.2643 29.0077Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.217 21.4119C33.0741 20.5235 38.181 18.4358 38.5679 16.9255C39.1095 15.1488 31.836 15.9039 29.6694 16.126C25.9553 16.5258 22.009 17.1476 18.3723 17.7695C16.4378 18.0804 13.1106 18.7023 11.9499 19.6796C15.664 20.5235 21.7769 19.5019 25.9553 19.5019V20.1237C22.628 22.7001 17.0568 24.2548 12.8784 26.3425C10.1702 27.7195 7.53936 29.3186 5.37278 31.0065C4.28949 31.8505 2.74193 32.961 2.5098 33.9382C9.55118 31.2286 16.8247 27.6307 22.7828 24.1659C21.39 24.9211 20.152 25.9427 18.8365 26.8311C22.7054 26.5202 28.1219 22.9222 31.217 21.4119Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0541 68.6215C41.2126 69.5418 36.1423 71.7173 35.7814 73.234C35.2704 75.0199 42.5299 74.1394 44.6923 73.88C48.399 73.4162 52.334 72.7263 55.9595 72.0418C57.8884 71.6975 61.2044 71.0183 62.3481 70.0212C58.62 69.2415 52.5256 70.3684 48.3479 70.4405L48.3372 69.8187C51.6196 67.1854 57.1633 65.5348 61.3052 63.3753C63.9893 61.9518 66.5923 60.3075 68.7296 58.5825C69.7982 57.7199 71.3264 56.5829 71.5417 55.6018C64.548 58.4325 57.3374 62.1554 51.4397 65.7224C52.8193 64.9434 54.0396 63.9005 55.3396 62.9896C51.4766 63.3672 46.1228 67.0581 43.0541 68.6215Z",
    fill: "#8594A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6091 25.7501C69.4662 24.8617 74.5732 22.774 74.96 21.2637C75.5017 19.487 68.2282 20.2421 66.0616 20.4642C62.3474 20.864 58.4012 21.4858 54.7644 22.1077C52.83 22.4186 49.5027 23.0405 48.342 24.0178C52.0562 24.8617 58.169 23.8401 62.3474 23.8401L62.3474 24.4619C59.0202 27.0383 53.449 28.593 49.2706 30.6807C46.5624 32.0577 43.9315 33.6568 41.7649 35.3447C40.6816 36.1887 39.1341 37.2992 38.9019 38.2764C45.9433 35.5668 53.2169 31.9689 59.175 28.5041C57.7822 29.2593 56.5441 30.2809 55.2287 31.1693C59.0976 30.8584 64.514 27.2604 67.6091 25.7501Z",
    fill: "#8594A2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlasticWrap);
export default __webpack_public_path__ + "static/media/plastic_wrap.8864268b5249a0a2e85cd280c68aa5ac.svg";
export { ForwardRef as ReactComponent };